import { getSetPolicies } from './policyMeta';

/**
 * Sectioned policy body — icon + heading + full text per set policy.
 * Shared by PoliciesDrawer (all policies) and BookingConfirmationPage
 * ("Before your appointment" subset via `keys`). Returns null when
 * nothing matching is set.
 */
const PolicySections = ({ bookingPage, keys = null, dense = false }) => {
  const policies = getSetPolicies(bookingPage, keys);
  if (policies.length === 0) return null;

  return (
    <div className={dense ? 'space-y-4' : 'space-y-6'}>
      {policies.map(({ key, label, Icon, text }) => (
        <div key={key}>
          <div className="flex items-center gap-2 mb-1.5">
            <Icon
              className={`${dense ? 'h-4 w-4' : 'h-5 w-5'} text-themed-secondary flex-shrink-0`}
              aria-hidden="true"
            />
            <h3 className="font-medium text-themed-primary">{label}</h3>
          </div>
          <p
            className={`text-sm text-themed-secondary whitespace-pre-wrap leading-relaxed ${
              dense ? 'pl-6' : 'pl-7'
            }`}
          >
            {text}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PolicySections;
